<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1"></HeaderNav>
    <Banner :banner="bannerList"  @click="loseFocus()"></Banner>
    <div class="pro_box container">	
	<ul>
		<li>
			<a @click="toDetail(1)"><i>一抹轻龄</i>
			<div class="li_img"><img src="static/picture/1-210p9150s5l2.png"></div>
			<div class="li_text">
				<p>晶泽面霜<em>Face Cream</em></p>
				<span>锁水焕肤 弹润紧致</span>
			</div></a>
		</li><li>
			<a @click="toDetail(2)"><i>精准修护</i>
			<div class="li_img"><img src="static/picture/1-210p9140gb36.png"></div>
			<div class="li_text">
				<p>晶泽精华<em>High Quality Essence</em></p>
				<span>精准修护 抗氧焕亮</span>
			</div></a>
		</li><li>
			<a @click="toDetail(3)"><i>柔光底妆</i>
			<div class="li_img"><img src="static/picture/1-210g2152i5532.jpg"></div>
			<div class="li_text">
				<p>隔离霜<em>Base Cream</em></p>
				<span>养修持防 均透润亮</span>
			</div></a>
		</li><li>
			<a @click="toDetail(4)"><i>科学锁水</i>
			<div class="li_img"><img src="static/picture/1-210319142439614.jpg"></div>
			<div class="li_text">
				<p>佐伯面霜<em>Chizu Cream</em></p>
				<span>高效锁水 润泽焕新</span>
			</div></a>
		</li><li>
			<a @click="toDetail(5)"><i>智能储水</i>
			<div class="li_img"><img src="static/picture/1-210319141i6301.jpg"></div>
			<div class="li_text">
				<p>佐伯乳液<em>Chizu Emulsion</em></p>
				<span>焕活滋养 透亮水润</span>
			</div></a>
		</li><li>
			<a @click="toDetail(6)"><i>赋活焕颜</i>
			<div class="li_img"><img src="static/picture/1-2103191412123m.jpg"></div>
			<div class="li_text">
				<p>眼霜<em>Eye Cream</em></p>
				<span>抚纹提拉 焕活眼周</span>
			</div></a>
		</li><li>
			<a @click="toDetail(7)"><i>周期护理</i>
			<div class="li_img"><img src="static/picture/1-21022011402bj.jpg"></div>
			<div class="li_text">
				<p>去角质霜<em>Gommage Cleansing</em></p>
				<span>净澈焕亮 水感嫩滑</span>
			</div></a>
		</li><li>
			<a @click="toDetail(8)"><i>专注修护</i>
			<div class="li_img"><img src="static/picture/1-21022011302i43.jpg"></div>
			<div class="li_text">
				<p>涂抹面膜<em>Moist Cream Pack</em></p>
				<span>修护润泽 维稳肌肤</span>
			</div></a>
		</li><li>
			<a @click="toDetail(9)"><i>明星产品</i>
			<div class="li_img"><img src="static/picture/1-200g4122121b0.jpg"></div>
			<div class="li_text">
				<p>肌底液<em>Repair Essence</em></p>
				<span>修护肌底 提升肤质</span>
			</div></a>
		</li><li>
			<a @click="toDetail(10)"><i>明星产品</i>
			<div class="li_img"><img src="static/picture/1-2009160uf0208.jpg"></div>
			<div class="li_text">
				<p>佐伯水<em>Chizu Lotion</em></p>
				<span>深层滋润 持久保湿</span>
			</div></a>
		</li><li>
			<a @click="toDetail(11)"><i>粉丝挚爱</i>
			<div class="li_img"><img src="static/picture/1-200g4160t4435.jpg"></div>
			<div class="li_text">
				<p>平衡水<em>Rich Lotion</em></p>
				<span>舒缓肌肤 深层滋润</span>
			</div></a>
		</li><li>
			<a @click="toDetail(12)"><i>粉丝挚爱</i>
			<div class="li_img"><img src="static/picture/1-200g4123g0235.jpg"></div>
			<div class="li_text">
				<p>精华液<em>CellCosme</em></p>
				<span>深层滋养 紧致焕颜</span>
			</div></a>
		</li><li>
			<a @click="toDetail(13)"><i>清洁优选</i>
			<div class="li_img"><img src="static/picture/1-200g4160602415.jpg"></div>
			<div class="li_text">
				<p>清洁面膜<em>Aqua Clay Pack</em></p>
				<span>深层清洁 柔嫩肌肤</span>
			</div></a>
		</li><li>
			<a @click="toDetail(14)"><i>清洁优选</i>
			<div class="li_img"><img src="static/picture/1-200g415424x63.jpg"></div>
			<div class="li_text">
				<p>洗面奶<em>Cleansing Foam</em></p>
				<span>有效洁净 亲和肌肤</span>
			</div></a>
		</li><li>
			<a @click="toDetail(15)"><i>滋养之星</i>
			<div class="li_img"><img src="static/picture/1-200g4154055603.jpg"></div>
			<div class="li_text">
				<p>平衡面霜<em>Rich Cream</em></p>
				<span>绵密柔润 保湿滋养</span>
			</div></a>
		</li><li>
			<a @click="toDetail(16)"><i>滋养之星</i>
			<div class="li_img"><img src="static/picture/1-200g415145sg.jpg"></div>
			<div class="li_text">
				<p>面膜<em>Refine Cellmask</em></p>
				<span>焕肤滋养 水润呵护</span>
			</div></a>
		</li>
		
	</ul>
</div>
<hr class="hr_1 mb80">
    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import Banner from '../../components/Banner.vue';
import RightNav from '../../components/RightNav.vue';
import { apiGetDetail, apiChangeOther, apiAddNotes } from '../../api/job.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banner: Banner,
    RightNav: RightNav
  },
  data() {
    return {
      advertInfo: { image: '../../static/pC/ad.png' },
      id:'',
      login: false, //是否登录
      userInfo: [] ,//是否登录--用户信息
      bannerList: [
        {url:'static/picture/luara_banner1.jpg'},
        {url:'static/picture/luara_banner2.jpg'},
        {url:'static/picture/luara_banner3.jpg'},
      ],
    };
  },
  created() {
    this.id = this.$route.query.id;
  },
  methods: {
    toDetail(id){
		this.$router.push({ path: '/activity', query: { id:id } });
	},
    //跳转到外部链接
    linkOut(url){
      if(url.includes('https://') || url.includes('http://') ){
      	window.location.href = url
      }else{
      	window.location.href = `https://${url}`
      }
    },
    
    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    }
  }
};
</script>
<style scoped>
/*------------luara.html  start----------------*/	
.classify_box{
	width: 100%;
	height: 116px;
	overflow: hidden;
	background: #fafafa;
}
.classify_box p{
	margin-top: 12px;
	text-align: right;
	padding-right: 60px;
	font-size: 12px;
	color: #000000;
	font-family: Font_Light;
}
.classify_box select{
	width: 198px;
	padding: 0 15px;
	height: 40px;
	line-height: 40px;
	border: 1px solid #000;
	background: none;
	float: right;
	margin: 12px 30px 0 0;
	font-size: 14px;
	color: #000000;
	font-family: Font_Light;
}

.pro_box{
	overflow: hidden;
}
.pro_box li{
	width: 30%;
	margin: 0 5% 8% 0;
	float: left;
	text-align: center;
	overflow: hidden;
	position: relative;
}
.pro_box li:nth-child(3n){
	margin: 0 0 8% 0;
}
.pro_box li a{
	color: #000;
}
.pro_box li a:hover{
	color: #000;
}
.pro_box li i{
	display: block;
	width: 80px;
	text-align: center;
	height: 20px;
	line-height: 20px;
	letter-spacing: 1px;
	font-style: normal;
	font-size: 13px;
	font-family: Font_Regular;
	border: 1px solid #000;
	z-index: 2;
	margin: 40px auto 0;
}
.pro_box li .li_img{
	width: 100%;
	overflow: hidden;
	padding-top: 135%;
	position: relative;
}
.pro_box li .li_img img{
	max-width: 100%;
	max-height: 100%;
	display: block;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	margin: auto;
}
.pro_box li .li_text{
	text-align: center;
}
.pro_box li .li_text p{
	letter-spacing: 2px;
	font-size: 15px;
	font-family: Font_Medium;
    margin: 0 0 10px 0;
}
.pro_box li .li_text p em{
	letter-spacing: 1px;
	display: block;
	font-style: normal;
}
.pro_box li .li_text span{
	display: inline-block;
	padding: 0 16px;
	text-align: center;
	letter-spacing: 2px;
	height: 34px;
	line-height: 34px;
	color: #fff;
	background: #000;
	font-size: 15px;
	font-family: Font_Normal;
}
/*------------luara.html  end----------------*/	
</style>


// WEBPACK FOOTER //
// src/view/Html/LUARA.vue